/*
 * barcode-search.js
 * ----------------------------------------------------------------------------
 * Shopify's storefront full-text search (/search) is typo-tolerant and returns
 * unrelated products for long numeric queries — so scanning/typing a barcode
 * surfaces wrong items (e.g. a random book ranked above the real match).
 *
 * This intercepts barcode-like searches (all digits, 8–14 long) and resolves
 * them against the predictive endpoint scoped to the barcode/sku fields, which
 * returns the exact product. One match -> go straight to that product. Zero or
 * many -> fall back to the normal search results page.
 *
 * Plain text searches are untouched (fuzzy matching is wanted there).
 */
(function () {
  var BARCODE_RE = /^\d{8,14}$/;
  var FIELDS = 'title,product_type,variants.barcode,variants.sku,vendor';

  function predictiveBase() {
    return (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  }

  function searchUrlBase() {
    // Derive the (locale-prefixed) search URL from the predictive route:
    // "/en-gb/search/suggest" -> "/en-gb/search".
    return predictiveBase().replace(/\/suggest$/, '');
  }

  function suggestJsonUrl() {
    return predictiveBase() + '.json';
  }

  function isBarcode(q) {
    return BARCODE_RE.test(q);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('role') !== 'search') return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var q = input.value.trim();
      if (!isBarcode(q)) return; // ordinary search — leave Shopify's default behaviour

      // Take over: stop the form's normal (fuzzy) submit and the predictive handler.
      event.preventDefault();
      event.stopPropagation();

      var fallback = function () {
        window.location.href =
          searchUrlBase() + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product';
      };

      var url =
        suggestJsonUrl() +
        '?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4' +
        '&resources[options][fields]=' +
        encodeURIComponent(FIELDS);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : Promise.reject(response.status);
        })
        .then(function (data) {
          var products =
            (((data || {}).resources || {}).results || {}).products || [];
          if (products.length === 1 && products[0].url) {
            window.location.href = products[0].url; // exact barcode hit
          } else {
            fallback(); // 0 or several — let the user choose on the results page
          }
        })
        .catch(fallback);
    },
    true // capture phase: run before predictive-search.js' own submit handler
  );
})();

